export enum ValidationState {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  VALID = 'VALID',
  INVALID = 'INVALID'
}
